import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3c3c3c",
      "fill-rule": "evenodd",
      d: "M3.692.462a.462.462 0 0 1 .923 0 .77.77 0 0 0 .77.769.462.462 0 0 1 0 .923.77.77 0 0 0-.77.77.462.462 0 1 1-.923 0 .77.77 0 0 0-.769-.77.462.462 0 0 1 0-.923.77.77 0 0 0 .77-.77m.462 1.161-.07.07.07.069.07-.07zM9.366.135c.18-.18.472-.18.653 0l1.846 1.846c.18.18.18.473 0 .653l-9.23 9.23a.46.46 0 0 1-.654 0L.135 10.02a.46.46 0 0 1 0-.653L7.52 1.981zM7.846 2.96 1.114 9.692l1.194 1.194L9.04 4.154zm1.846.541L8.5 2.308l1.193-1.194 1.194 1.194zm.616 2.653c.255 0 .461.206.461.461a.77.77 0 0 0 .77.77.461.461 0 1 1 0 .923.77.77 0 0 0-.77.769.462.462 0 1 1-.923 0 .77.77 0 0 0-.77-.77.462.462 0 0 1 0-.922.77.77 0 0 0 .77-.77c0-.255.207-.461.462-.461m0 1.623-.07.07.07.068.069-.069z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }